<template>
  <modal name="modal-admin-order-alarm-log" class="modal-inner modal-admin-order-alarm-log" transition="pop-out" :width="modalWidth" :focus-trap="true" :min-height="600" height="auto" :scrollable="true" :resizable="true" :adaptive="true" :reset="true">
    <span class="close-button" @click="hide('modal-admin-order-alarm-log')"><BaseIcon icon="times-circle" class="text-white"/></span>
    <div class="modal-header">
      Beställ
    </div>
    <div class="modal-body text-sm" v-if="log_info">
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Kund:
        </div>
        <div class="float-right">
          <!-- links to the customer's unit list / the unit's alarm list when the order carries the ids -->
          <span v-if="customerRoute" class="cursor-pointer text-primary-500 hover:underline" :title="customerRoute" @click.prevent="goTo(customerRoute)">{{ getCustomerDisplayName() }}</span>
          <span v-else>{{ getCustomerDisplayName() }}</span>
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Verksamhetsnamn:
        </div>
        <div class="float-right">
          <span v-if="unitRoute" class="cursor-pointer text-primary-500 hover:underline" :title="unitRoute" @click.prevent="goTo(unitRoute)">{{ getUnitDisplayName() }}</span>
          <span v-else>{{ getUnitDisplayName() }}</span>
        </div>
      </div>

      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>

      <div class="clear-both py-2">
        <div class="float-left font-bold">
          Beställarens uppgifter
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Namn:
        </div>
        <div class="float-right">
          {{ customerInfo.contact_name }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          E-post:
        </div>
        <div class="float-right">
          {{ customerInfo.contact_email }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Telefonnummer:
        </div>
        <div class="float-right">
          {{ customerInfo.contact_phone }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Företagsnamn:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ customerInfo.company_name }}</pre>
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Fakturaadress:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ customerInfo.invoice_detail }}</pre>
        </div>
      </div>

      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>

      <div class="clear-both py-2">
        <div class="float-left font-bold">
          Generella frågor
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left">
          Sker en del av arbetet utomhus, eller genom hembesök?
        </div>
        <div class="float-right">
          {{ customerInfo.outdoor_work }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left">
          Vill ni kunna larma mellan kollegor?
        </div>
        <div class="float-right">
          {{ customerInfo.alert_members }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left">
          Vill ni veta vart i huset man befinner sig vid larmning?
        </div>
        <div class="float-right">
          {{ customerInfo.indoor_tracking }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left">
          Vill ni att larm ska aktiveras om personen som bär larmet ramlar (Mandown)?
        </div>
        <div class="float-right">
          {{ customerInfo.man_down_alert }}
        </div>
      </div>

      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>

      <div class="clear-both py-2">
        <div class="float-left font-bold">
          {{ $t('admin_order_alarm.alarm_basis') }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left">
          Antal personer som ska använda larmet:
        </div>
        <div class="float-right">
          {{ customerInfo.total_user }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left">
          Vad heter personen/gruppen?
        </div>
        <div class="float-right">
          {{ customerInfo.person_group_names }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left">
          Personens/ gruppens arbetsuppgifter:
        </div>
        <div class="float-right">
          {{ customerInfo.work_task }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left">
          Arbetsplatsens ort:
        </div>
        <div class="float-right">
          {{ customerInfo.working_place }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left">
          Finns det idag någon hot- eller riskbild som du vill att larmcentralen skall veta?
        </div>
        <div class="float-right">
          {{ customerInfo.risk_detail }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left">
          Övrig information:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ customerInfo.other_info }}</pre>
        </div>
      </div>

      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>

      <div class="clear-both pt-2">
        <div class="float-left font-semibold">
          Säljare:
        </div>
        <div class="float-right">
          {{ getSellerName(log_info.seller) }}
        </div>
      </div>
      <div class="clear-both pt-2">
        <div class="float-left font-semibold">
          Larmcentral:
        </div>
        <div class="float-right">
          {{ alarmCenterLabel(log_info.alarm_center) }}
        </div>
      </div>
      <div class="clear-both pt-2">
        <div class="float-left font-semibold">
          Simkort:
        </div>
        <div class="float-right">
          {{ log_info.sim_card }}
        </div>
      </div>
      <div class="clear-both pt-2">
        <div class="float-left font-semibold">
          Direct dispatch:
        </div>
        <div class="float-right">
          {{ log_info.direct_dispatch ? 'Ja' : 'Nej' }}
        </div>
      </div>
      <!-- external contractor (guard dispatch): the order carries it only when
           direct dispatch is on, so it is shown in that case -->
      <template v-if="log_info.direct_dispatch">
        <div class="clear-both pt-2">
          <div class="float-left font-semibold">
            {{ $t('admin_order_alarm.security_company') }}:
          </div>
          <div class="float-right">
            {{ log_info.security_company || $t('order_log.not_specified') }}
          </div>
        </div>
        <div class="clear-both pt-2">
          <div class="float-left font-semibold">
            {{ $t('alarm_create.contact_number') }}:
          </div>
          <div class="float-right">
            {{ log_info.security_company_phone || $t('order_log.not_specified') }}
          </div>
        </div>
        <div class="clear-both pt-2" v-if="log_info.security_company_object_id">
          <div class="float-left font-semibold">
            {{ $t('alarm_create.object_id') }}:
          </div>
          <div class="float-right">
            {{ log_info.security_company_object_id }}
          </div>
        </div>
      </template>
      <!-- assignee + shipping fields -->
      <div class="clear-both pt-2">
        <div class="float-left font-semibold">
          {{ $t('order_log.assignee') }}:
        </div>
        <div class="float-right">
          {{ log_info.assignee_name || $t('order_log.not_specified') }}
        </div>
      </div>
      <!-- demo feedback: the delivery method replaced the yes/no shipping
           question; older orders show the old answer instead -->
      <div class="clear-both pt-2">
        <div class="float-left font-semibold">
          {{ $t('admin_order_alarm.delivery_method') }}:
        </div>
        <div class="float-right">
          {{ deliveryMethodLabel(log_info) }}<span v-if="log_info.direct_shipping_address"> — {{ log_info.direct_shipping_address }}</span>
        </div>
      </div>
      <div class="clear-both pt-2" v-if="log_info.delivery_tracking_link">
        <div class="float-left font-semibold">
          {{ $t('admin_order_alarm.delivery_tracking_link') }}:
        </div>
        <div class="float-right">
          {{ log_info.delivery_tracking_link }}
        </div>
      </div>

      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>

      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Avtalsnummer:
        </div>
        <div class="float-right font-bold">
          {{ log_info.agreement_number }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Avtalsperiod:
        </div>
        <div class="float-right">
          {{ log_info.contract_period }}
        </div>
      </div>
      <div class="clear-both pt-2">
        <div class="float-left font-semibold">
          Uppläggningsavgift:
        </div>
        <div class="float-right">
          {{ formatAmount(log_info.setup_fee) }}
        </div>
      </div>
      <div class="clear-both pt-2">
        <div class="float-left font-semibold">
          Hyreskostnad:
        </div>
        <div class="float-right">
          {{ formatAmount(log_info.rental_month_cost) }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Betalningsvillkor:
        </div>
        <div class="float-right">
          {{ log_info.payment_terms }}
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Avtalsstart:
        </div>
        <div class="float-right">
          {{ log_info.contract_start }}
        </div>
      </div>

      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Särskilda villkor:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ log_info.special_terms }}</pre>
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          När behöver beställningen vara klar:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ log_info.delivery_period }}</pre>
        </div>
      </div>

      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>

      <!-- demo feedback: a personal order describes one person per alarm -
           every one of them is shown here, with their own alarm's answers -->
      <template v-if="orderPeople.length">
        <div class="clear-both pb-1 font-bold">
          {{ $t('admin_order_alarm.personal_details') }}
        </div>
        <!-- overflow-hidden contains the floated rows: without it the last
             line hangs outside the box and reads as cut off -->
        <div class="clear-both mb-3 border border-gray-200 rounded p-3 overflow-hidden" v-for="(person, i) in orderPeople" :key="`order-person-${i}`">
          <div class="clear-both pb-2 font-semibold">
            {{ $t('admin_order_alarm.personal_person', { n: i + 1 }) }}
          </div>
          <div class="clear-both py-1" v-for="row in personRows(person)" :key="row.label">
            <div class="float-left">{{ row.label }}:</div>
            <div class="float-right">
              <pre class="font-sans whitespace-pre-line">{{ row.value }}</pre>
            </div>
          </div>
          <div class="clear-both"></div>
        </div>
      </template>

      <template v-else>
        <div class="clear-both py-2">
          <div class="float-left font-semibold">
            Riskprofil:
          </div>
          <div class="float-right">
            {{ riskLabel(log_info.risk_profile) }}
          </div>
        </div>
        <div class="clear-both py-2">
          <div class="float-left font-semibold">
            Utgår från adress:
          </div>
          <div class="float-right">
            {{ log_info.from_address }}
          </div>
        </div>
        <div class="clear-both pt-2">
          <div class="float-left font-semibold">
            Namn på produkter:
          </div>
          <div class="float-right">
            <pre class="font-sans whitespace-pre-line">{{ log_info.alarms_name }}</pre>
          </div>
        </div>
      </template>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Kommentar till orderhantering:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ log_info.comment }}</pre>
        </div>
      </div>

      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>

      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Information SecurCloud:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ log_info.info_securcloud }}</pre>
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Kontaktpersoner:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ contactPersonsText }}</pre>
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Lösenord:
        </div>
        <div class="float-right">
          {{ log_info.alarm_password }}
        </div>
      </div>

      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>

      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Internlarm
        </div>
        <div class="float-right">
          <BaseIcon v-if="log_info.call_button" icon="check-circle" class="text-success-500" />
          <BaseIcon v-else icon="times-circle" class="text-red-500" />
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Timeralarm
        </div>
        <div class="float-right">
          <BaseIcon v-if="log_info.timer_alarm" icon="check-circle" class="text-success-500" />
          <BaseIcon v-else icon="times-circle" class="text-red-500" />
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          Mandown
        </div>
        <div class="float-right">
          <BaseIcon v-if="log_info.man_down" icon="check-circle" class="text-success-500" />
          <BaseIcon v-else icon="times-circle" class="text-red-500" />
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          9-Vibb
        </div>
        <div class="float-right">
          <BaseIcon v-if="log_info.nine_vib" icon="check-circle" class="text-success-500" />
          <BaseIcon v-else icon="times-circle" class="text-red-500" />
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          SMS:
        </div>
        <div class="float-right">
          <div v-for="(n, i) in log_info.sms_numbers" :key="i">
            {{ n.msisdn }}
          </div>
        </div>
      </div>

      <!-- demo feedback: who gets notified when an alarm goes off - shown
           read-only here, edited on the order form behind the pencil -->
      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>
      <div class="clear-both pb-1 font-bold">
        {{ $t('admin_order_alarm.notifications_section') }}
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          {{ $t('admin_order_alarm.notifications_general') }}
        </div>
        <div class="float-right">
          <BaseIcon v-if="hasGeneralNotifications" icon="check-circle" class="text-success-500" />
          <BaseIcon v-else icon="times-circle" class="text-red-500" />
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          {{ $t('admin_order_alarm.email') }}:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ notificationEmailsText }}</pre>
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          {{ $t('admin_order_alarm.phone') }}:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ notificationPhonesText }}</pre>
        </div>
      </div>
      <div class="clear-both py-2" v-if="customerInfo.email_sms_detail">
        <div class="float-left font-semibold">
          {{ $t('admin_order_alarm.legacy_free_text') }}:
        </div>
        <div class="float-right">
          <pre class="font-sans whitespace-pre-line">{{ customerInfo.email_sms_detail }}</pre>
        </div>
      </div>
      <div class="clear-both py-2">
        <div class="float-left font-semibold">
          {{ $t('admin_order_alarm.notifications_individual') }}
        </div>
        <div class="float-right">
          <BaseIcon v-if="hasIndividualNotifications" icon="check-circle" class="text-success-500" />
          <BaseIcon v-else icon="times-circle" class="text-red-500" />
        </div>
      </div>
      <div class="clear-both py-2" v-if="log_info.notification_individual_detail">
        <div class="float-right w-full">
          <pre class="font-sans whitespace-pre-line">{{ log_info.notification_individual_detail }}</pre>
        </div>
      </div>

      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>
      <div v-if="isCashAgreement()" class="text-s text-black-600 font-bold mb-1"> {{ $t('alarm_create.cash_agreement') }}</div>
      <template v-for="(p, index) in productLines()">
        <div v-bind:key="index" class="clear-both py-2" v-if="p.qty > 0">
          <div class="float-left font-semibold">
            <div>{{ p.display_name || p.name }}</div>
            <div v-if="p.display_name && p.display_name !== p.name" class="text-xs text-gray-500 font-normal ml-2">{{ p.name }}</div>
            <div v-if="p.articleNumber" class="text-xs text-gray-500 font-normal ml-2">{{ p.articleNumber }}</div>
          </div>
          <div class="float-right">{{ p.qty }} * {{ getProductCost(p) }} </div>
        </div>
      </template>

      <div class="clear-both border-b border-secondary-400 pt-4 mb-3"></div>
    </div>
  </modal>
</template>

<script>
import { riskProfileLabel } from "@/utils/alarmEnums";

const MODAL_WIDTH = 800;

export default {
  name: "adminOrderAlarmLogModal",
  props: {
    log_info: {
      required: true,
      default: null,
    },
    customers: {
      required: true,
      default: [],
    },
    units: {
      required: true,
      default: null,
    },
    sellers: {
      required: true,
      default: [],
    },
    alarm_centers: {
      required: true,
      default: [],
    },
  },

  data() {
    return {
      sim_operators: ["Telia", "Telia DCP", "Telenor", "Tele2", "Kundens Simkort"],
    };
  },

  computed: {
    // The people carrying the alarms (personal orders only). An order saved
    // before the list existed shows its single set of rows instead.
    orderPeople() {
      const people = Array.isArray(this.log_info.personal_alarms) ? this.log_info.personal_alarms : [];
      return people.filter((person) => person && Object.values(person).some((value) => String(value || "").trim()));
    },

    // The notification recipients, as stored on the order: the e-mails are one
    // comma-separated string, the numbers a list of entries.
    notificationEmailsText() {
      const emails = String(this.log_info.notification_email || "")
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean);
      return emails.length ? emails.join("\n") : "-";
    },

    notificationPhonesText() {
      const numbers = (this.log_info.notification_phone || [])
        .map((entry) => String((entry && entry.msisdn) || "").trim())
        .filter(Boolean);
      return numbers.length ? numbers.join("\n") : "-";
    },

    // Ticked when the order says so, and also when it simply carries
    // recipients - orders saved before the checkboxes existed have no flag.
    // Same rule the order form itself uses when it opens such an order.
    hasGeneralNotifications() {
      if (this.log_info.notify_general === true) return true;
      return this.notificationEmailsText !== "-" || this.notificationPhonesText !== "-";
    },

    hasIndividualNotifications() {
      if (this.log_info.notify_individual === true) return true;
      return Boolean(this.log_info.notification_individual_detail);
    },

    user() {
      return this.$store.state.user;
    },

    // The customer/unit routes take the viewer's role as :type and the role's
    // own id as :id, same as sidebar_menu.getId(). Admins browse as
    // "customer" with "-".
    routeTypeAndId() {
      const u = this.user || {};
      if (u.role === "seller") return { type: "seller", id: u.seller_id || "-" };
      if (u.role === "reseller") return { type: "reseller", id: u.reseller_id || "-" };
      return { type: "customer", id: "-" };
    },
    customerRoute() {
      if (!this.log_info || !this.log_info.customer_id) return null;
      const { type, id } = this.routeTypeAndId;
      return `/verksamheter/${type}/${this.log_info.customer_id}/${id}`;
    },
    unitRoute() {
      if (!this.log_info || !this.log_info.customer_id || !this.log_info.unit_id) return null;
      const { type, id } = this.routeTypeAndId;
      return `/larm/${type}/${this.log_info.customer_id}/${this.log_info.unit_id}/${id}`;
    },
    // Legacy orders may have no customer_info at all — always give the
    // template an object to read from.
    customerInfo() {
      return (this.log_info && this.log_info.customer_info) || {};
    },
    // Structured contact persons rendered one per line; orders written
    // before the rows existed fall back to their free text.
    contactPersonsText() {
      const rows = (this.log_info && Array.isArray(this.log_info.contact_persons) ? this.log_info.contact_persons : [])
        .map((row) => [row.name, row.function, row.phone, [row.weekday, row.saturday, row.sunday].filter(Boolean).join('/')]
          .map((part) => String(part || '').trim())
          .filter(Boolean)
          .join(', '))
        .filter(Boolean);
      if (rows.length) return rows.join('\n');
      return (this.log_info && this.log_info.contact_person) || '';
    },
  },

  methods: {
    riskLabel(value) {
      return riskProfileLabel((k) => this.$t(k), value);
    },

    // One person's answers, skipping what they left empty
    personRows(person) {
      const rows = [
        { label: this.$t('admin_order_alarm.risk_profile'), value: this.riskLabel(person.risk_profile) },
        { label: this.$t('admin_order_alarm.from_address'), value: person.from_address },
        { label: this.$t('alarm_create.reporting'), value: person.reporting },
        { label: this.$t('alarm_create.name'), value: person.name },
        { label: this.$t('alarm_create.home_address'), value: person.home_address },
        { label: this.$t('alarm_create.transport'), value: this.transportLabel(person.transport) },
        { label: this.$t('alarm_create.registration_number'), value: person.registration_number },
        { label: this.$t('alarm_create.model'), value: person.model },
        { label: this.$t('alarm_create.color'), value: person.color },
        { label: this.$t('admin_order_alarm.product_names'), value: person.alarms_name },
        { label: this.$t('admin_order_alarm.password'), value: person.alarm_password },
      ];
      return rows.filter((row) => String(row.value || "").trim());
    },

    // 'walking'/'car'/... as the order form writes them; an unknown value is
    // shown as it was stored
    transportLabel(value) {
      const key = String(value || "").trim();
      if (!key) return "";
      const labels = {
        walking: this.$t('alarm_create.transport_walking'),
        bike: this.$t('alarm_create.transport_bike'),
        public_transport: this.$t('alarm_create.transport_public_transport'),
        car: this.$t('alarm_create.transport_car'),
      };
      return labels[key] || key;
    },
    // demo feedback: how the devices reach the customer. Orders saved before
    // the delivery method existed only have the yes/no answer.
    deliveryMethodLabel(order) {
      const labels = {
        salesperson: this.$t('admin_order_alarm.delivery_to_salesperson'),
        customer_pickup: this.$t('admin_order_alarm.delivery_customer_pickup'),
        recipient: this.$t('admin_order_alarm.delivery_to_recipient'),
      };
      if (order && order.delivery_method && labels[order.delivery_method]) return labels[order.delivery_method];
      if (order && order.direct_shipping === 'yes') return labels.recipient;
      return this.$t('order_log.not_specified');
    },
    getCustomerName(customer_id) {
      let c = _.find(this.customers, { customer_id: customer_id });
      if (c) return c.name;
      else return "";
    },
    isCashAgreement(){
      return this.log_info && this.log_info.agreement_category === 'cash_services';
    },

    // Get customer name with fallback to stored customer_info for cross-country orders
    getCustomerDisplayName() {
      if (!this.log_info) return "";
      let c = _.find(this.customers, { customer_id: this.log_info.customer_id });
      if (c) return c.name;
      // Fallback to stored company_name for cross-country orders
      if (this.customerInfo.company_name) {
        return this.customerInfo.company_name;
      }
      return "";
    },

    getUnitName(unit_id) {
      let u = _.find(this.units, { unit_id: unit_id });
      if (u) return u.name;
      else return "";
    },

    // Get unit name with fallback to stored customer_info for cross-country orders
    getUnitDisplayName() {
      if (!this.log_info) return "";
      let u = _.find(this.units, { unit_id: this.log_info.unit_id });
      if (u) return u.name;
      // Fallback to stored unit_name for cross-country orders
      if (this.customerInfo.unit_name) {
        return this.customerInfo.unit_name;
      }
      return "";
    },

    getProductCost(product){
      if (!product) return 0;
      // Check for price first (the primary price field set by backend)
      // Then check rental_price, and only use cash_price if it's actually > 0
      if (product.price !== undefined && product.price !== null && product.price > 0) {
        return product.price;
      }
      if (product.rental_price !== undefined && product.rental_price !== null && product.rental_price > 0) {
        return product.rental_price;
      }
      if (product.cash_price !== undefined && product.cash_price !== null && product.cash_price > 0) {
        return product.cash_price;
      }
      return 0;
    },

    getSellerName(seller_id) {
      let s = _.find(this.sellers, { _id: seller_id });
      if (s) return s.name;
      else return "";
    },

    getAlarmCenterName(alarm_center_id) {
      let a = _.find(this.alarm_centers, { _id: alarm_center_id });
      if (a) return a.name;
      else return "";
    },

    // SEC-405: "Ingen" chosen in the order form is saved as "-", and Norway has
    // an alarm centre record called "Ingen alarmsentral". Both read "Ingen".
    alarmCenterLabel(alarm_center_id) {
      if (alarm_center_id === "-") return this.$t("admin_order_alarm.none");
      // a centre without a name gives "" (getAlarmCenterName returns its name as it is)
      const name = String(this.getAlarmCenterName(alarm_center_id) || "");
      if (name.trim().toLowerCase() === "ingen alarmsentral") return this.$t("admin_order_alarm.none");
      return name;
    },

    // SEC-405: the order's product lines, one per variant. An order saved from
    // the agreement form keeps the chosen variants inside the product (qty 0 on
    // the product itself), so each ordered variant is listed as its own line.
    productLines() {
      const lines = [];
      (this.log_info.products || []).forEach((p) => {
        if (p.qty > 0) lines.push(p);
        (p.variants || []).forEach((v) => {
          if (!(v.qty > 0)) return;
          lines.push({
            display_name: `${p.display_name || p.name} - ${v.name}`,
            name: `${p.name} - ${v.name}`,
            articleNumber: v.articleNumber,
            qty: v.qty,
            price: v.price,
            rental_price: v.rental_price,
            cash_price: v.cash_price,
          });
        });
      });
      return lines;
    },

    showAdminOrderLogModal(log) {
      this.log_info = log;
      this.$modal.show("modal-admin-order-alarm-log");
    },

    show(id) {
      this.$modal.show(id);
    },

    // New tab, so the order list and this modal stay where the user left them.
    goTo(path) {
      window.open(this.$router.resolve(path).href, "_blank", "noopener");
    },

    hide(id) {
      this.$modal.hide(id);
    },
  },

  created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? window.innerWidth : MODAL_WIDTH;
  },
};
</script>
